import kr from '../kr/kr';
import axios from 'axios';
import tingle from 'tingle.js/dist/tingle';
import 'tingle.js/dist/tingle.css';
import '../../css/delivery.css';
import OrlenPaczka from './delivery/OrlenPaczka';
import Interface from './delivery/Interface';
import HTMLClass from '../kr/utils/HTMLClass';
import { OpenStreetMapProvider } from 'leaflet-geosearch';


//import HTMLClass from '../../kr/utils/HTMLClass';

export default class DeliveryPointMap extends kr.Component {
    init() {
        this._supportedDeliveries = [52];
        this._supportedDeliveriesClass = {
            52: OrlenPaczka
        }
        /** @type {Interface[]} */
        this._deliveryClass;
        this._callbackToLoad = ['markercluster', 'lcontrol'];
        this._leafletLoaded = false;
        this._modal;
        this._inner;
        this._content = '';
        this._$map;
        this._$mapLocate;
        this._pins = [];
        this._markers = [];
        this._suggestionContainer;
        this._fillingSuggestion = false;
        this._searchProvider = new OpenStreetMapProvider({
            params: {
                'accept-language': 'pl',
                'countrycodes': 'pl'
            }
        });
        this._selectedMarker;
        this._args = {
            city: '',
            is_cod: false
        }

        this.bind();
        
    }
    
    bind() {
        this.on('change', 'input[name="dostawa"]', (target, event) => {
            event.preventDefault();
            const intValue = parseInt(target.value);
            if (!this._supportedDeliveries.includes(parseInt(intValue))) {
                return;
            }
            
            /** @type {Interface[]} */
            this._deliveryClass = new this._supportedDeliveriesClass[intValue]();
            this.run();
        });

        this.on('click', '.btn-min', (target, event) => {
            event.preventDefault();
            const input = target.parentNode.parentNode.querySelector('input[name="dostawa"]');
            if (!input) {
                return;
            }
            const intValue = parseInt(input.value);
            if (!this._supportedDeliveries.includes(parseInt(intValue))) {
                return;
            }
            
            /** @type {Interface[]} */
            this._deliveryClass = new this._supportedDeliveriesClass[intValue]();
            this.run();
        });
    }

    run() {
        if (!this._modal) {
            this._modal = new tingle.modal({
                closeMethods: ['overlay', 'button', 'escape'],
                closeLabel: "Zamknij",
                cssClass: ['tingle--pointsmap'],
                footer: true,
                stickyFooter: false,
                onClose: () => {
                    this._content = '';
                    this._modal.setContent('');
                }
            });
            this._modal.addFooterBtn('Zamknij', 'btn-min tingle-btn--pull-right', () => {
                this._modal.close();
            });
        }
        this._markers = [];
        this.setArgs();
        this._modal.open();
        this._modal.setContent(this._loadTemplate());
        this._suggestionContainer = this._inner.querySelector('div.js-pointsmap-suggestion')
        this._pins = this._deliveryClass.getPins();
        this._loadLeaflet();
        this._bindMapEvents();
        this._loadArgs();
    }

    _loadArgs()
    {
        const input = this._inner.querySelector('input.js-pointsmap-input');
        if (this._args.city.length > 0) {
            input.value = this._args.city;
            this._searchInput(this._args.city);
        }
    }

    _bindMapEvents()
    {
        const input = this._inner.querySelector('input.js-pointsmap-input');
        input.addEventListener('keypress', (event) => {
            if (event.which != 13) {
                return;
            }
            const value = input.value;
            this._searchInput(value);
        });
        this._inner.querySelector('a.js-pointsmap-search-submit').addEventListener('click', (event) => {
            event.preventDefault();
            const value = input.value;
            if (!value) {
                return;
            }
            this._searchInput(value);
        });
        this._inner.querySelector('a.js-pointsmap-local-me').addEventListener('click', (event) => {
            event.preventDefault();
            this._$mapLocate.start();
        });
    }

    async _searchInput(query)
    {
        const result = await this._searchProvider.search({query: query});
        if (result.length > 0) {
            this._$map.setView([result[0].y, result[0].x], 15)
        }
    }

    _showPins()
    {
        const pinArgs = this._deliveryClass.getPinIcon();
        pinArgs.iconUrl = window.cdnUrl+pinArgs.iconUrl;
        const mapPin = L.icon(pinArgs);
        const markers = L.markerClusterGroup({
            showCoverageOnHover: false,
		    chunkedLoading: true
        });
        this._pins.then(data => {
            for (let key in data) {
                const pin = data[key];
                if (this._args.is_cod && pin.cod == 0) {
                    continue;
                }
                const div = document.createElement('div');
                HTMLClass.addClass(div, 'pointsmap__marker');
                div.innerHTML = `
                    <p><strong>${pin.p_type} ${pin.p_id}</strong></p>
                    <ul>
                        <li>${pin.s}, ${pin.c}<br>${pin.d}</li>
                        <li>Otwarte: ${pin.hours}</li>
                    </ul>
                `;
                const button = document.createElement('button');
                HTMLClass.addClass(button, 'btn-min');
                HTMLClass.addClass(button, 'color1');
                HTMLClass.addClass(button, 'js-check-point');
                button.setAttribute('data-index', key);
                button.setAttribute('data-id', pin.id);
                button.innerHTML = 'Wybieram';
                div.appendChild(button);
                const marker = 
                    L.marker([pin.lat, pin.lng], {icon: mapPin})
                        .bindPopup(div)
                        .on('click', () => {
                            this._setSelected(marker);
                        });
                this._markers.push(marker);
                markers.addLayer(marker);

                button.addEventListener('click', event => {
                    event.preventDefault();
                    this._pointSelected(button.getAttribute('data-index'));
                });
            }
            this._$map.addLayer(markers);
        });
    }
    _setSelected(marker) 
    {
        this._selectedMarker = marker;
    }

    _fillSuggestion()
    {
        if (this._fillingSuggestion) {
            return;
        }
        this._fillingSuggestion = true;
        this._pins.then(pins => {
            const center = this._$map.getCenter();
            const bounds = this._$map.getBounds();

            this._suggestionContainer.innerHTML = '';
            let count = 0;
            const array = [];
            for (let key in this._markers) {
                const marker = this._markers[key];
                if (!bounds.contains(marker.getLatLng())) {
                    continue;
                }
                count++;
                if (count > 300) {
                    this._suggestionContainer.innerHTML = '<p>Przybliż mapkę aby zobaczyć sugestię</p>';
                    return;
                }
                const content = marker._popup.getContent();
                const index = content.querySelector('button').getAttribute('data-index');
                const pin = pins[index];
                const point2 = L.latLng(pin.lat, pin.lng);
                array.push({
                    distance: center.distanceTo(point2),
                    txt: content
                });
                //const div = document.createElement('div');
                //div.appendChild();
                //this._suggestionContainer.appendChild(div);
            }

            array.sort(function(a, b) {
                return a.distance - b.distance;
            });

            count = 0;
            const div = document.createElement(div);
            for (let i in array) {
                count++;
                if (count > 5) {
                    break;
                }
                const popup = array[i].txt.cloneNode(true);
                const button = popup.querySelector('button.js-check-point');
                button.addEventListener('click', event => {
                    event.preventDefault();
                    this._pointSelected(button.getAttribute('data-index'));
                });
                div.appendChild(popup);
            }
            this._suggestionContainer.appendChild(div);
            this._fillingSuggestion = false;
        })
    }

    _pointSelected(index)
    {
        this._pins.then(pins => {
            const pin = pins[index];
            const evt = new CustomEvent(`deliverypoint_filled_${this._deliveryClass.getSlug()}`, {
                detail: {
                    pin: pin
                }
            });
            document.dispatchEvent(evt);
            this._modal.close();
        }) 
    }

    _loadLeaflet()
    {
        if (this._leafletLoaded) {
            this._initLeafletCallback2();
            return;
        }
        this.app.addCss('https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.3/leaflet.min.css');
        this.app.addCss('https://cdnjs.cloudflare.com/ajax/libs/leaflet.markercluster/1.5.3/MarkerCluster.Default.min.css');
        this.app.addCss('https://cdnjs.cloudflare.com/ajax/libs/leaflet-locatecontrol/0.79.0/L.Control.Locate.min.css');
        this.app.addJs('https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.3/leaflet.min.js', true, this._initLeafletCallback.bind(this));
    }
    
    _initLeafletCallback()
    {
        this.app.addJs('https://cdnjs.cloudflare.com/ajax/libs/leaflet.markercluster/1.5.3/leaflet.markercluster.js', true, this._initLeafletCallback2.bind(this, 'markercluster'));
        this.app.addJs('https://cdnjs.cloudflare.com/ajax/libs/leaflet-locatecontrol/0.79.0/L.Control.Locate.min.js', true, this._initLeafletCallback2.bind(this, 'lcontrol'));
    }

    _initLeafletCallback2(js = null)
    {   
        if (js !== null) {
            const indexOf = this._callbackToLoad.indexOf(js);
            if (indexOf != -1) {
                this._callbackToLoad.splice(indexOf, 1);
            }

            if (this._callbackToLoad.length > 0) {
                return;
            }
        }
        this._leafletLoaded = true;
        this._$map = L.map('leaflet-map-points').setView([52.229675, 21.012230], 15);
        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,
            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        }).addTo(this._$map);

        this._showPins();
        this._$map.on('resize', () =>  {this._fillSuggestion();});
        this._$map.on('zoomend', () =>  {this._fillSuggestion();});
        this._$map.on('moveend', () =>  {this._fillSuggestion();});
        this._$mapLocate = L.control.locate({
            locateOptions: {
                maxZoom: 15,
                showPopup: false,
            }
        }).addTo(this._$map);
    }
    setArgs()
    {
        const inputCity = document.getElementById('fmiejscowosc');
        if (inputCity) {
            this._args.city = inputCity.value;
        }
        const paymentChecked = document.querySelector('input[name="platnosc"]:checked');
        if (!paymentChecked) {
            this._args.is_cod = false;
            return;
        }
        this._args.is_cod = paymentChecked.value == 2;
    }

    _loadTemplate()
    {
        let head = this._deliveryClass.getLogo();
        if (head) {
            head = `<span class="pointsmap__head__logo"><img src="${window.cdnUrl}${head}" loading="lazy" /></span>`;
        } else {
            head = `<span class="pointsmap__head__text">${this._deliveryClass.getName()}</span>`;
        }
        this._inner = document.createElement('div');
        HTMLClass.addClass(this._inner, 'pointsmap');

        this._inner.innerHTML = `
            <h2 class="pointsmap__head">Wybierz punkt odbioru ${head}</h2>
            <div class="pointsmap__form">
                <div class="pointsmap__row pointsmap__row--jc-c">
                    <div class="pointsmap__col pointsmap__col--50">
                        <input type="text" class="cart-dataform pointsmap__input js-pointsmap-input" placeholder="Wpisz miasto lub kod"/>
                    </div>
                    <div class="pointsmap__col">
                        <div class="pointsmap__buttons">
                            <a href="#" class="btn-large color1 js-pointsmap-search-submit pointsmap__button">Pokaż</a>
                            <a href="#" class="btn-large color2 js-pointsmap-local-me pointsmap__button">Zlokalizuj mnie</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="pointsmap__row">
                <div class="pointsmap__col pointsmap__col--75">
                    <div class="pointsmap__map" id="leaflet-map-points">Wczytuję...</div>
                </div>
                <div class="pointsmap__col pointsmap__col--25">
                    <aside class="pointsmap__aside">
                        <h3 class="pointsmap__aside__head">Punkty w pobliżu</h3>
                        <div class="pointsmap__aside__ul js-pointsmap-suggestion">
                        </div>
                    </aside>
                </div>
            </div>
        `;
        
        return this._inner;
    }
}

kr.registerComponent('#fcartmethods', {
    component: DeliveryPointMap
});